<div>
  <button style="float: right;" title="{{'labels.close' | translate}}" (click)="closeDialog()" mat-icon-button color="warn" aria-label="icon-button save">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div style="text-align: center"><h2>{{'labels.startRevision' | translate}}</h2>
    <mat-form-field>
        <input [(ngModel)]="revisionNumber" type="number" matInput name="value"
               placeholder="{{'labels.versionNumber' | translate}}"
        >
    </mat-form-field>
    <br><br>
    <hr>
    <br>
    <button mat-stroked-button (click)="sendRevision()">{{'buttons.send' | translate}}</button>
</div>
